export default __webpack_public_path__ + "static/media/slider-unraf-1.500cc5ee.jpg";